<!-- Button trigger modal -->
<div class="btn-trigger">
  <button
    type="button"
    class="btn btn-psp-primary add-cst"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
    (click)="openModal()"
  >
    <span>+</span>
    <span class="text"> Add New Customer </span>
  </button>
</div>
<app-choose-customer-modal></app-choose-customer-modal>
<div class="container-fluid">
  <div class="filter-list-container d-flex justify-content-between mt-5 mb-5">
    <button
      class="btn btn-icon"
      [ngClass]="{ active: apiParams.patientSubscriptionTypeId == 0 }"
      type="button"
      (click)="onSearch(0)"
    >
      <span class="btn-inner--text"> All Tasks </span>
      <span class="span-number align-items-centery">
        {{ pspTasksCounter.all }}
      </span>
    </button>

    <button
      class="btn btn-icon"
      type="button"
      [ngClass]="{ active: apiParams.patientSubscriptionTypeId == 3 }"
      (click)="onSearch(3)"
    >
      <span class="btn-inner--text"> Pre-Registration Patients </span>
      <span class="span-number align-items-centery">
        {{ pspTasksCounter.preRegistrationPatients }}
      </span>
    </button>

    <button
      class="btn btn-icon"
      type="button"
      [ngClass]="{ active: apiParams.patientSubscriptionTypeId == 1 }"
      (click)="onSearch(1)"
    >
      <span class="btn-inner--text"> Pending Patients </span>
      <span class="span-number align-items-centery">
        {{ pspTasksCounter.pendingPatients }}
      </span>
    </button>

    <button
      class="btn btn-icon"
      type="button"
      [ngClass]="{ active: apiParams.patientSubscriptionTypeId == 2 }"
      (click)="onSearch(2)"
    >
      <span class="btn-inner--text"> Pending Caregivers </span>
      <span class="span-number align-items-centery">
        {{ pspTasksCounter.pendingCaregivers }}
      </span>
    </button>
  </div>

  <!-- <page-header-search *ngIf="hasRochePermission" -->
  <page-header-search 
    [isSearchInput]="hasRochePermission"
    [pageTitleValue]="'Daily Tasks'"
    placeholderValue="Search by Enrollment ID"
    (onHeaderSearchSubmit)="onEnrollmentIdSearch($event)"
    [searchString]="currentSearchValue"
  >
  </page-header-search>

  <div class="card">
    <div class="card-header border-0 d-flex justify-content-end">
        <app-companies-select class="col-md-2" (companySelected)="onCompanySelected($event)"></app-companies-select>
    </div>
    
      <ngx-datatable
        class="material ngx-datatable-custom"
        [rows]="tasksArray"
        [columns]="columns"
        [limit]="apiParams.pageSize"
        [offset]="apiParams.currentPage-1"
        columnMode="force"
        externalPaging="true"
        [count]="totalItems"
        [scrollbarH]="true"
        [headerHeight]="50"
        [footerHeight]="50"
        rowHeight="auto"
        (page)="onChangePage($event)"
        selectionType="single"
        (select)="routeToPspDetails($event)"
        [messages]="messages"
        [externalPaging]="true"
      >
        <!-- Patient Name Template -->
        <ng-template let-row="row" #patientNameRef ngx-datatable-cell-template>
          <span class="ng-star-inserted">{{ row.patient?.name || row.careReceiver?.name }}</span>
        </ng-template>

        <!-- Attached Rx Template -->
        <ng-template let-row="row" #attachedRxRef ngx-datatable-cell-template>
          <div class="d-flex align-items-center">
            <ng-container *ngIf="row.doctor?.rxUrl;">
              <button 
                class="btn btn-sm btn-outline-primary" 
                (click)="viewAttachedRx(row, $event); $event.stopPropagation()"
              >
                <i class="fas fa-eye"></i> View
              </button>
              <button 
                class="btn btn-sm btn-outline-primary ms-1" 
                (click)="downloadAttachedRx(row, $event); $event.stopPropagation()"
              >
                <i class="fas fa-download"></i> Download
              </button>
            </ng-container>
          </div>
        </ng-template>
      </ngx-datatable> 
  </div> 
<ngx-spinner></ngx-spinner>